// Keep existing interfaces for backward compatibility
export interface Shipment {
    id: string;
    location: string;
    name: string;
    campaign: string;
    item: string;
    quantity: string;
    organization: string;
    logistics: string;
    notifyDonors: boolean;
}

export interface ShipmentDonation {
    shipment: {
        name: string;
    };
}

/**
 * Shipment status enum
 * Maps to API field 'currentStutus'
 */
export enum ShipmentStatus {
    CREATED = 'Created',
    SHIPPED = 'Shipped',
    MISSING = 'Missing',
    DELIVERED = 'Delivered'
}

/**
 * Enhanced shipment interface that directly maps to the API response
 * Handles all the field naming quirks and type conversions
 */
export interface ShipmentDetail {
    id: number;
    supplierId: string;
    supplierCode: string;
    name: string;
    label: string;
    status: ShipmentStatus; // Maps from currentStutus in API
    orderedBoxes: number; // Maps from orderedBoxUnit in API
    notifyDonors: boolean; // Maps from notifyDoner in API
    active: boolean;
    shipmentAlerts: number;
    logisticsDetails: string;
    organization: string; // Maps from orgenization in API
    languageCode: string;
    createdAt: string; // Maps from createAt in API
    updatedAt: string;
    address: string;
    latitude: number; // Converted from string in API
    longitude: number; // Converted from string in API, maps from longtitude

    // Derived fields
    campaignName: string;
    campaignId: number;
    donatedBars: number;
    donations: number;
    amount: number;
    createdByEmail: string;
    createdByName: string;
    fulfilledBoxes: number; // Calculated field

    // Optional fields that might be present in detailed view
    user?: any;
    products?: any[];
    createdBy?: number;
}

/**
 * Simplified interface for list views
 */
export interface ShipmentListItem {
    id: number;
    name: string;
    campaignName: string;
    organization: string;
    donatedBars: number;
    orderedBoxes: number;
    fulfilledBoxes: number;
    status: ShipmentStatus;
    createdAt: string;
}

/**
 * Interface for filtering shipments
 */
export interface ShipmentFilter {
    campaign?: number; // Campaign ID
    status?: ShipmentStatus[];
    organization?: string;
    dateFrom?: string;
    dateTo?: string;
    search?: string; // For searching by name
    showDeactivated?: boolean;
    page?: number;
    limit?: number;
    sortBy?: 'createdAt' | 'updatedAt' | 'status' | 'name' | 'campaignName';
    sortOrder?: 'asc' | 'desc';
}

/**
 * API response for shipment list
 */
export interface ShipmentListResponse {
    data: ShipmentDetail[];
    pagination: {
        page: number;
        limit: number;
        total: number;
    };
}

export interface ShipmentHistoryItem {
    id: number;
    supplierId: string;
    title: string;
    type: string;
    createdDate: string;
    shipmentId: number;
    userName: string | null;
    userEmail: string | null;
    ordered: number;
}
